import { useEffect } from 'react';

const COLORS = ['#AB2328', '#76232F', '#33d17a', '#f6d32d', '#D0D3D4'];
const PIECE_COUNT = 150;

export function Confetti() {
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return undefined;
    }

    const canvas = document.createElement('canvas');
    canvas.className = 'confetti-canvas';
    document.body.appendChild(canvas);

    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const pieces = Array.from({ length: PIECE_COUNT }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height - canvas.height,
      radius: Math.random() * 6 + 4,
      drift: Math.random() * PIECE_COUNT,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      tilt: Math.floor(Math.random() * 10) - 10,
      tiltSpeed: Math.random() * 0.07 + 0.05,
      tiltAngle: 0,
    }));

    let frameId = 0;
    let active = true;

    function draw() {
      if (!active) return;

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      pieces.forEach((piece) => {
        ctx.beginPath();
        ctx.lineWidth = piece.radius / 2;
        ctx.strokeStyle = piece.color;
        ctx.moveTo(piece.x + piece.tilt + piece.radius / 4, piece.y);
        ctx.lineTo(piece.x + piece.tilt, piece.y + piece.tilt + piece.radius / 4);
        ctx.stroke();

        piece.tiltAngle += piece.tiltSpeed;
        piece.y += (Math.cos(piece.drift) + 3 + piece.radius / 2) / 2;
        piece.tilt = Math.sin(piece.tiltAngle) * 15;

        if (piece.y > canvas.height) {
          piece.y = -20;
        }
      });

      frameId = requestAnimationFrame(draw);
    }

    frameId = requestAnimationFrame(draw);

    return () => {
      active = false;
      cancelAnimationFrame(frameId);
      canvas.remove();
    };
  }, []);

  return null;
}
